import styled from 'styled-components';

import logo from '../../assets/images/baemingo_logo_white.svg';

export const PoweredByWrapper = styled.div`
  text-align: center;
  margin-top: 70px;
  display: flex;
  flex-flow: column nowrap;
  align-items: center;

  @media all and (max-height: 850px) {
    margin-top: 10px;
    margin-bottom: 10px;
  }
`;

export const PoweredByText = styled.div<{
  isDark?: boolean;
}>`
  font-size: 14px;
  font-weight: 500;
  line-height: 24px;
  color: ${(props) => (props.isDark ? 'var(--colorBlueGray700)' : 'var(--colorBlueGray900)')};
`;

export const Logo = styled.div<{
  isDark?: boolean;
}>`
  margin-top: 8px;
  height: 14px;
  width: 176px;
  mask-image: url(${logo});
  mask-size: contain;
  mask-position: center;
  mask-repeat: no-repeat;
  background-color: ${(props) => (props.isDark ? 'var(--colorBlack)' : 'var(--colorWhite)')};
`;
